module.exports = __webpack_public_path__ + "static/media/download.13a89981.svg";